import { render, staticRenderFns } from "./reportIBox.vue?vue&type=template&id=b674da3e&scoped=true"
import script from "./reportIBox.vue?vue&type=script&lang=js"
export * from "./reportIBox.vue?vue&type=script&lang=js"
import style0 from "./reportIBox.vue?vue&type=style&index=0&id=b674da3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b674da3e",
  null
  
)

export default component.exports